<template>
    <div class="myCard p-5">
        <div class="cardBody">
            <div class="title">
                <div class="iconContainer">
                    <img :src="require(`@/assets/icons/${this.icon}.svg`)" alt="icon" class="icon" />
                </div>
                <h2>{{ this.title }}</h2>
            </div>

            <div class="main">
                <slot></slot>
            </div>

            <div class="bottom ">
                <template v-if="hasButton">
                <button class="btn btn-outline-primary" type="button">
                    <a :href="buttonHref">{{ buttonTitle }}</a>
                    <i class="fas fa-arrow-right"></i>
                </button>

                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "NewIconBox",
    props: {
        icon: {
            type: String,
            default: function() {
                return "fas fa-cogs"
            }
        },
        title: {
            type: String,
            required: true,
            default: function() {
                return "NO TITLE"
            }
        },
        buttonTitle: {
            type: String,
            required: false,
            default: function() {
                return undefined;
            }
        },
        buttonHref: {
            type: String,
            required: false,
            default: function() {
                return undefined
            }
        }
    },
    computed: {
        hasButton: function() {
            return this.buttonTitle !== undefined && this.buttonHref !== undefined;
        }
    }
}
</script>

<style lang="scss" scoped>
    $border-radius: 20px;
    $icon-size: 80px;
    
    .myCard {
        border-radius: $border-radius;
        background: $white;
        height: 100%;
        width: 100%;
        overflow-y: auto;

    }

    .cardBody {
        display: flex;
        flex-flow: column;
        height: 100%;
        width: 100%;
        margin: 0;
        font-family: "Noto Serif";
        color: #474a57;
        font-weight: 300;
        font-size: 16px;
    }

    h1 {
        word-break: break-word;
        display: flex;
        flex-direction: column;
    }

    h2 {
        font-family: "Noto Serif SC";
        color: $text-color;
        margin-top: 25px;
        font-size: 40px;
        line-height: 1.2;
        overflow-wrap: break-word;
        hyphens: auto;
        @media (max-width: 768px) {
            font-size: 30px;
            margin-top: 15px;
            // line-height: 2rem;
        }
    }

    .main {
        flex: 2;
        overflow: auto;
        display: flex; 
        flex-direction: column;

        h4 {
            font-size:medium;
        }

        p {
            margin: 0;
            font-family: "Noto Serif";
        }
    }

    .bottom {
    }

    .iconContainer {
        height: $icon-size; 
        line-height: $icon-size;
    }

    .icon {
        height: 100%; 
        width: $icon-size; 
        border-radius: calc(#{$icon-size} / 2); 
        line-height: inherit
    }

    .fas {
        color: $primary-color;
    }

    .divider > hr {
        background-color: $primary-color !important;
    }

    a {
        color: white;
        text-decoration: none;
    }


    .btn {
        margin-top: 25px;
        border-radius: 5px;
        font-size: 16px;
        display: flex;
        gap: 5px;
        justify-content: center;
        align-items: center;
        padding: 12px 30px;
        a {
            color: $primary-color;
        }
        i{
            -webkit-text-stroke: 1.2px $white;
        }
    }

    .main p {
        font-family: 'Noto Serif SC', serif;
        color: $text-color;
        font-weight: 400;
        font-size: 0.99rem; 
        line-height: 1.625rem; 
        letter-spacing: 0.02em;
    }

    .btn-outline-primary {
        background-color: transparent !important;
        border-color: $primary-color !important;
        color: $primary-color !important;
    }

    .btn-outline-primary.active.show {
        background-color: $primary-color !important;
        color: white !important;
    }



</style>